import { render, staticRenderFns } from "./BindComponent.vue?vue&type=template&id=0e4d0a34&scoped=true"
import script from "./BindComponent.vue?vue&type=script&lang=js"
export * from "./BindComponent.vue?vue&type=script&lang=js"
import style0 from "./BindComponent.vue?vue&type=style&index=0&id=0e4d0a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d0a34",
  null
  
)

export default component.exports